import { useState, useEffect } from 'react';

import { useLazyGetComparablesByNidQuery } from '../../../../../apis/comparables-by-nid/comparables-by-nid.endpoints';
import { IComparableRow } from '../../../types';

interface UseCompsDataReturn {
  rows: IComparableRow[] | null;
  loading: boolean;
  error: string | null;
  fetchComps: (nid: string) => void;
  reset: () => void;
}

export const useCompsData = (): UseCompsDataReturn => {
  // El país viene de localStorage (igual que el resto de la app)
  const country = localStorage.getItem('country') || process.env.REACT_COUNTRY || 'CO';

  const [visible, setVisible] = useState(false);
  const [getComparables, { data, isFetching, isError }] =
    useLazyGetComparablesByNidQuery();

  // Garantiza que visible arranque en false aunque HMR preserve el estado anterior
  useEffect(() => {
    setVisible(false);
  }, []);

  const fetchComps = (nid: string) => {
    setVisible(true);
    getComparables({ country, nid });
  };

  const reset = () => setVisible(false);

  const rows = visible && data && data.length > 0 ? data : null;

  let visibleError: string | null = null;
  if (isError) {
    visibleError = 'Error al consultar el servicio. Intenta de nuevo.';
  } else if (data?.length === 0) {
    visibleError = 'No se encontraron comparables para este NID.';
  }

  const error = visible ? visibleError : null;

  return { rows, loading: isFetching, error, fetchComps, reset };
};
